import type { EntityData } from '@ContractBuilder/types';
import { useTemplates } from '@queries/fetchTemplates';

import { filterPublishedTemplates } from '../utils/filterPublishedTemplates';
import { isTemplateResource } from '../utils/isTemplateResource';

export const useTemplatesData = (submission?: EntityData) => {
  const { data: templates = [], isLoading: isFetchingTemplates } = useTemplates();

  const publishedTemplates = templates.filter(filterPublishedTemplates);
  const canRefreshCurrentTemplate =
    isTemplateResource(submission?.sourceResourceName) &&
    publishedTemplates.some((template) => template.id === submission?.sourceResourceId);

  return { templates: publishedTemplates, canRefreshCurrentTemplate, isFetchingTemplates };
};
